export function fmt(n, digits = 2) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function fmtInt(n) {
  if (n === null || n === undefined) return "—";
  return Number(n).toLocaleString();
}

export function fmtDate(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleString(undefined, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function today() {
  return new Date().toISOString().slice(0, 10);
}

export function roleLabel(role) {
  const map = {
    administrator: "Administrator",
    poultry_supervisor: "Poultry Supervisor",
    health_caregiver: "Health Caregiver",
    construction_supervisor: "Construction Supervisor",
    finance_officer: "Finance Officer",
    inventory_officer: "Inventory Officer",
    guest: "Guest",
  };
  return map[role] || role;
}
